/** Static copy from PCL 25-26 31-08-26.xlsm — sheets P0 / P1 / P1.x1 */

import type {G0Page} from '@/pages/components/audit-program/g-section/constants';
import type {JBreakdownPage, JRemark} from '@/pages/components/audit-program/j-section/constants';

export type PSectionPageCode = 'P0' | 'P1' | 'P1.x1';

export const P_SECTION_PAGES: PSectionPageCode[] = ['P0', 'P1', 'P1.x1'];

export const P_PAGE_TITLES: Record<PSectionPageCode, string> = {
    P0: 'Audit programme - Income taxes',
    P1: 'Tax recoverable/(payable)',
    'P1.x1': 'Income tax expenses',
};

export type PProgrammePage = G0Page;

export const P0_PAGE: PProgrammePage = {
    title: 'AUDIT PROGRAMME - INCOME TAXES',
    rows: [
        {id: 'r1', kind: 'section', num: '', text: 'General', level: 0},
        {id: 'r2', kind: 'main', num: '1', text: 'Obtain and check, or prepare, a lead schedule for the current year\'s figures and reconcile this to the general ledger.', level: 0},
        {id: 'r3', kind: 'main', num: '2', text: 'Carry out analytical procedures such as:', level: 0},
        {id: 'r4', kind: 'sub', num: '(a)', text: 'comparison of the current figures with those of prior periods;', level: 1},
        {id: 'r5', kind: 'sub', num: '(b)', text: 'review and comparison of key ratios or other performance indicators.', level: 1},
        {id: 'r6', kind: 'main', num: '3', text: 'Review for items above performance materiality or that are otherwise unusual and verify.', level: 0},
        {id: 'r7', kind: 'section', num: '', text: 'Current tax', level: 0},
        {id: 'r8', kind: 'main', num: '4', text: 'Obtain and check, or prepare the following:', level: 0},
        {id: 'r9', kind: 'sub', num: '(a)', text: 'tax computations;', level: 1},
        {id: 'r10', kind: 'sub', num: '(b)', text: 'an analysis of movement on the current tax account (including local tax and overseas tax);', level: 1},
        {id: 'r11', kind: 'sub', num: '(c)', text: 'a proof of tax/tax reconciliation.', level: 1},
        {id: 'r12', kind: 'main', num: '5', text: 'Ensure profit before tax used in the computation agrees to profit and loss account.', level: 0},
        {id: 'r13', kind: 'section', num: '', text: 'Deferred taxation', level: 0},
        {id: 'r14', kind: 'main', num: '6', text: 'Calculate or review the calculation of the full potential deferred tax liability and consider what provision, if any, is necessary.', level: 0},
        {id: 'r15', kind: 'section', num: '', text: 'Presentation and disclosure', level: 0},
        {id: 'r16', kind: 'main', num: '7', text: 'Ensure that there is sufficient appropriate evidence on the file to support all disclosures made.', level: 0},
        {id: 'r17', kind: 'section', num: '', text: 'Bespoke tests', level: 0},
        {id: 'r18', kind: 'main', num: '8', text: 'Draft and perform any necessary additional tests such as those required by C8.3 and cross reference with the objectives on the summary sheet.', level: 0},
        {id: 'r19', kind: 'section', num: '', text: 'Conclusion', level: 0},
        {id: 'r20', kind: 'main', num: '9', text: 'Consider whether there are any items which need to be included in a letter of representation or letter of comment and record this on A5 or A6 as appropriate.', level: 0},
        {id: 'r21', kind: 'main', num: '10', text: 'Review the planned extent of reliance on internal controls in this area and consider whether this remains appropriate.', level: 0},
        {id: 'r22', kind: 'main', num: '11', text: 'Assess whether the initial materiality and/or risk assessment should be revised in view of the audit evidence obtained. Record details of any necessary adjustments on B6 or B9. Consider the impact on the remainder of the audit work and on any work undertaken to date.', level: 0},
    ],
};

const P_REMARKS: JRemark[] = [
    {tick: '<', text: 'Per bank statement'},
    {tick: 'V', text: 'Checked to invoices'},
    {tick: '✓', text: 'Confirmed and agreed'},
    {tick: 'b', text: "Per last year's working paper"},
    {tick: '>', text: 'Per ledger'},
    {tick: '^', text: 'Casting checked'},
];

export type PLeadPage = JBreakdownPage;

export const P1_PAGE: PLeadPage = {
    title: 'Tax recoverable/(payable)',
    subtitle: 'Tax payable',
    amountLabel: 'Tax recoverable/(payable)',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: P_REMARKS,
    blankBreakdownRows: 8,
};

export const P1_X1_PAGE: PLeadPage = {
    title: 'Taxation',
    subtitle: 'Income tax expenses',
    amountLabel: 'Taxation',
    breakdownTitle: 'Breakdown of income tax expenses',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: [
        {tick: 'V', text: 'Checked to invoices'},
        {tick: 'b', text: "Per last year's working paper"},
        {tick: '>', text: 'Per ledger'},
        {tick: '^', text: 'Casting checked'},
    ],
    blankBreakdownRows: 8,
};
